import styled from 'styled-components';

// TODO: Remove and use the one in components folder

const VerticalSpacer = styled.div`
  height: ${props => props.height};
  ${props => (props.backgroundColor ? `background-color: ${props.backgroundColor};` : null)};
`;

export default VerticalSpacer;
